// extracted by mini-css-extract-plugin
export default {"mobileStyle":"CoreAddStoredPaymentForm_mobileStyle__mIkNN","webStyle":"CoreAddStoredPaymentForm_webStyle__CJXjo"};